import type { ReactNode } from 'react';
import type { TipusAcces } from '@/api/types';
import { useMe } from './MeContext';
import type { ContextAmbit } from './permisos';

export function Permis({
  recurs,
  tipus,
  ctx,
  children,
  alternativa = null,
}: {
  recurs: string;
  tipus: TipusAcces;
  ctx?: ContextAmbit;
  children: ReactNode;
  alternativa?: ReactNode;
}) {
  const { pot } = useMe();
  return <>{pot(recurs, tipus, ctx) ? children : alternativa}</>;
}
